(function () {
    const featureSection = document.querySelector('#about-features');
    const featureIcons = document.querySelectorAll('#about-features .feature-card i');
    if (featureSection && featureIcons.length) {
        const iconObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    featureIcons.forEach((icon, i) => {
                        icon.style.animationDelay = (i * 0.15) + 's';
                        icon.classList.add('icon-animate');
                    });
                    iconObserver.disconnect();
                }
            });
        }, { threshold: 0.1 });

        iconObserver.observe(featureSection);
    }
})();

(function () {
    const productItems = document.querySelectorAll('#about-products .col-12');
    if (productItems.length) {
        const productObserver = new IntersectionObserver((entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    productItems.forEach((item, i) => {
                        item.style.animationDelay = (i * 0.12) + 's';
                        item.classList.add('product-animate');
                    });
                    productObserver.disconnect();
                }
            });
        }, { threshold: 0.15 });

        productObserver.observe(productItems[0]);
    }
})();

// Stats
(function () {
    const counters = document.querySelectorAll('.stat-number');
    if (!counters.length) return;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const el = entry.target;
                const target = parseInt(el.getAttribute('data-target'), 10);
                const duration = 2000;
                const start = performance.now();

                function update(time) {
                    const elapsed = time - start;
                    const progress = Math.min(elapsed / duration, 1);
                    const eased = 1 - Math.pow(1 - progress, 4);
                    const current = Math.round(eased * target);
                    el.textContent = current.toLocaleString();
                    if (progress < 1) {
                        requestAnimationFrame(update);
                    } else {
                        el.textContent = target.toLocaleString();
                    }
                }

                requestAnimationFrame(update);
                observer.unobserve(el);
            }
        });
    }, { threshold: 0.5 });

    counters.forEach(counter => observer.observe(counter));
})();

// Homepage Swiper
const heroSwiper = new Swiper('.hero-swiper', {
    effect: 'fade',
    fadeEffect: {
        crossFade: true,
    }, 
    loop: true,
    speed: 1200,
    autoplay: {
        delay: 6000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        dynamicBullets: true,
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    keyboard: {
        enabled: true,
    },
    grabCursor: true,
    parallax: true,
});